// Commercial KPIs from GET /api/agent-runs/stats/cost (COST-CONTEXT-BUDGET-001).
// Cost figures cover PRICED runs only (a run whose model has no registered price has no cost), so the
// tooltip always says how many runs that is; nothing is shown when there is nothing to show.

const money = (v) => `$${v < 0.01 ? v.toFixed(4) : v.toFixed(2)}`;
const pct = (v) => `${Math.round(v * 1000) / 10}%`;

function Chip({ value, label, title, tone = "gray" }) {
  const tones = {
    gray: "bg-gray-50 border-gray-200 text-gray-600",
    amber: "bg-amber-50 border-amber-200 text-amber-700",
  };
  return (
    <div className={`border rounded-lg px-4 py-2 flex items-center gap-2 ${tones[tone]}`} title={title}>
      <span className="font-semibold text-lg">{value}</span>
      <span className="text-sm">{label}</span>
    </div>
  );
}

export default function RunCostChips({ cost }) {
  if (!cost) return null;
  const coverage = cost.cost_coverage != null
    ? `הנתון מחושב על ${cost.priced_runs} מתוך ${cost.runs_total} ריצות (${pct(cost.cost_coverage)}) שיש להן תמחור`
    : "";
  const ctx = cost.context || {};

  return (
    <>
      {cost.cost_per_successful_resolution_usd != null && (
        <Chip
          value={money(cost.cost_per_successful_resolution_usd)}
          label="לפתרון"
          title={`עלות AI כוללת (גם של ריצות שנכשלו) חלקי ריצות שהסתיימו בהצלחה. ${coverage}`}
        />
      )}
      {cost.cost_per_ticket_usd != null && (
        <Chip
          value={money(cost.cost_per_ticket_usd)}
          label="לקריאה"
          title={`עלות AI ממוצעת לקריאה שנותחה. ${coverage}`}
        />
      )}
      {cost.cache_hit_rate != null && cost.cache_hit_rate > 0 && (
        <Chip value={pct(cost.cache_hit_rate)} label="מטמון" title="חלק מטוקני הקלט שנשלפו מהמטמון של הספק (זול יותר)" />
      )}
      {ctx.budget_drop_rate != null && ctx.budget_drop_rate > 0 && (
        <Chip
          value={pct(ctx.budget_drop_rate)}
          label="הקשר קוצץ"
          tone="amber"
          title={`אחוז מ-${ctx.runs_sampled} הריצות האחרונות שבהן תקציב ההקשר השמיט בלוק. ${
            ctx.over_budget_rate > 0 ? `בנוסף ${pct(ctx.over_budget_rate)} חרגו מהתקציב בגלל בלוקים חובה. ` : ""
          }`}
        />
      )}
    </>
  );
}
